let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fqBFU"), load("1HAEl")]).then(() => parcelRequire('f3FIN'));